import React from 'react';
import classNames from 'classnames';
import { useMatchXSBreakpoint } from '../../hooks';
import Paragraph from '../paragraph';
import IconButton from '../icon-button';
import ActionButton from '../action-button';
import Icon from '../icon';
import { iconsList } from '../icon/glyphs';
import { APPEARANCES, ALIGN } from './constants';
import getAppearanceConfig from './helpers/get-appearance-config';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
const NotificationMessage = ({
  title,
  description = '',
  iconGlyph = null,
  appearance = APPEARANCES.default,
  align = ALIGN.left,
  actionButtonLabel = '',
  isActionButtonLoading = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onActionButtonClick = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onClose = null,
}) => {
  const { iconType, actionButtonAppearance, titleAppearance } = getAppearanceConfig(appearance);

  const isLayoutMobile = !useMatchXSBreakpoint();
  const hasCloseButton = Boolean(onClose);
  const hasActionButton = Boolean(actionButtonLabel && onActionButtonClick);

  const notificationMessageClassName = classNames(
    'ws-ui-notification-message',
    `ws-ui-notification-message--${appearance}`,
    `ws-ui-notification-message--${align}`,
    { 'ws-ui-notification-message--layout-mobile': isLayoutMobile },
    { 'ws-ui-notification-message--with-icon': iconGlyph },
    { 'ws-ui-notification-message--with-close-button': hasCloseButton },
    { 'ws-ui-notification-message--with-action-button': hasActionButton }
  );

  const titleElement =
    typeof title === 'string' ? <Paragraph appearance={titleAppearance}>{title}</Paragraph> : title;
  const descriptionElement =
    typeof description === 'string' ? (
      <Paragraph size="small" appearance="medium-emphasis">
        {description}
      </Paragraph>
    ) : (
      description
    );

  return (
    <div className={notificationMessageClassName}>
      <div className="ws-ui-notification-message__content">
        {iconGlyph && (
          <div className="ws-ui-notification-message__icon">
            <Icon glyph={iconGlyph} type={iconType} size="100%" />
          </div>
        )}
        <div className="ws-ui-notification-message__text">
          {titleElement}
          {description && descriptionElement}
        </div>
        {hasActionButton && (
          <div className="ws-ui-notification-message__action-button">
            <ActionButton
              appearance={actionButtonAppearance}
              format="solid"
              size="small"
              // @ts-ignore TS(2322): Type 'string' is not assignable to type 'null | un... Remove this comment to see the full error message
              label={actionButtonLabel}
              fullWidth={isLayoutMobile}
              onClick={onActionButtonClick}
              isLoading={isActionButtonLoading}
            />
          </div>
        )}
      </div>
      {hasCloseButton && (
        <div className="ws-ui-notification-message__close-button">
          {/* @ts-ignore TS(2322): Type '(...args: any[]) => any' is not assignable t... Remove this comment to see the full error message */}
          <IconButton onClick={onClose} size="medium" glyph="close" transparent />
        </div>
      )}
    </div>
  );
};

export default NotificationMessage;
